import React from "react";
import styled from "styled-components";
import { Zoom } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import Fade from "react-reveal";

// slide images

import sliderOne from "../assets/images/home/one.jpg";
import sliderTwo from "../assets/images/home/two.jpg";
import sliderThree from "../assets/images/home/three.jpg";
import sliderFour from "../assets/images/home/four.jpg";
import sliderFive from "../assets/images/home/five.jpg";
import sliderSix from "../assets/images/home/six.jpg";
import sliderSeven from "../assets/images/home/seven.jpg";

// style
const StyledHomeScreen = styled.main`
  min-height: 88vh;
  .slide {
    width: 100%;
    height: 88vh;
    z-index: 5;
    transition-duration: 0.5s;
    background-position: center;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
`;
const HomeScreen = () => {
  return (
    <StyledHomeScreen>
      <Zoom arrows={false} scale={2} canSwipe={true}>
        <div className="slide slideOne ">
          <Fade bottom duration={1000}>
            <img src={sliderOne} alt="" />
          </Fade>
        </div>
        <div className="slide slideTwo">
          <img src={sliderTwo} alt="" />
        </div>
        <div className="slide slideThree">
          <img src={sliderThree} alt="" />
        </div>
        <div className="slide slideThree">
          <img src={sliderFour} alt="" />
        </div>
        <div className="slide slideThree">
          <img src={sliderFive} alt="" />
        </div>
        <div className="slide slideThree">
          <img src={sliderSix} alt="" />
        </div>
        <div className="slide slideThree">
          <img src={sliderSeven} alt="" />
        </div>
      </Zoom>
    </StyledHomeScreen>
  );
};

export default HomeScreen;
